import React from 'react'
import PropTypes from 'prop-types'
import { Wrapper, StatusButton } from './styled'
import { STATUS } from '../../constants'

export const Status = ({ t, selectedStatus, handleSelectStatus }) => (
  <Wrapper>
    <div className="ant-form-item-no-colon">
      {t('task.status')}
    </div>

    <div className="buttons">
      <StatusButton value={STATUS.NOT_STARTED} selected={selectedStatus === STATUS.NOT_STARTED} onClick={handleSelectStatus}>{t('task.not_started')}</StatusButton>
      <StatusButton value={STATUS.IN_PROGRESS} selected={selectedStatus === STATUS.IN_PROGRESS} onClick={handleSelectStatus}>{t('task.in_progress')}</StatusButton>
      <StatusButton value={STATUS.COMPLETED} selected={selectedStatus === STATUS.COMPLETED} onClick={handleSelectStatus}>{t('task.completed')}</StatusButton>
    </div>
  </Wrapper>
)

Status.propTypes = {
  t: PropTypes.func,
  selectedStatus: PropTypes.string,
  handleSelectStatus: PropTypes.func
}
